import { PermissionKeysByType } from './enum/PermissionKeysByType';
import { CommonUrl } from '../utils/CommonUrl';
import { getRouteDefaultRequiredLevel } from '../utils/getRouteDefaultRequiredLevel';
import { getAppRouteData } from '../utils/getAppRouteData';
import { PermissionResult } from './PermissionResult';
import { PermissionResultRecurring } from './PermissionResultRecurring';

export const PermissionCheck = {
    withKeys(permissionKeys = []) {
        return new PermissionResult(permissionKeys);
    },

    withTransactionType(type) {
        // console.log('zz runInspectionFn with TransactionType', type)
        const permissionKeys = PermissionKeysByType[type] || [];
        return new PermissionResult(permissionKeys);
    },

    withRecurring(type, isRecurring) {
        const checkByType = PermissionCheck.withTransactionType(type);
        const checkRecurring = (
            isRecurring ?
                PermissionCheck.withUrl(CommonUrl.instruction) :
                new PermissionResult()
        );

        const {defaultRequiredLevel} = checkRecurring;

        return new PermissionResultRecurring(checkByType.keys, checkRecurring.keys, defaultRequiredLevel);
    },

    withUrl(url) {
        // Getting a match
        const route = getAppRouteData(url);
        const permissionKeys = route?.permission || [];
        const defaultRequiredLevel = getRouteDefaultRequiredLevel(route);
        const defaultInhibitorModifiers = route?.inhibitorModifiers || [];
        const permissionCheckMethod = route?.permissionCheckMethod || null; // 'OR' or 'AND'

        return new PermissionResult(
            permissionKeys, defaultRequiredLevel, defaultInhibitorModifiers, permissionCheckMethod,
        );
    },

    withCurrentRoute() {
        if (!window || !window.location.pathname)
            return new PermissionResult();

        // Getting a match
        const route = getAppRouteData(window.location.pathname);
        const permissionKeys = route?.permission || [];
        const defaultRequiredLevel = getRouteDefaultRequiredLevel(route);
        const defaultInhibitorModifiers = route?.inhibitorModifiers || [];
        const permissionCheckMethod = route?.permissionCheckMethod || null; // 'OR' or 'AND'

        return new PermissionResult(
            permissionKeys, defaultRequiredLevel, defaultInhibitorModifiers, permissionCheckMethod,
        );
    },
};
